import React, { useState, useEffect } from "react";
import hero1 from "../../assets/sorin-01.png";
import hero2 from "../../assets/IMG_6345.JPEG";

const Hero = () => {
  const images = [hero1, hero2];
  const [currentImage, setCurrentImage] = useState(0);

  // Image carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 8000); // ✅ Changed: 6000 → 8000 (8 detik per gambar)
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          html, body {
            margin: 0;
            padding: 0;
            overflow-x: hidden;
            width: 100%;
            background-color: #f7f7f5;
          }
          
          body > div,
          #root,
          #root > div {
            margin: 0 !important;
            padding: 0 !important;
            width: 100%;
            overflow-x: hidden;
          }
          
          header {
            margin: 0 !important;
            padding-bottom: 0 !important;
          }

          #hero {
            max-width: 100vw !important;
          }

          #hero img {
            object-fit: contain !important;
          }

          @media (max-width: 768px) {
            #hero {
              aspect-ratio: 16 / 9;
              margin-top: 120px !important;
            }
            #hero img {
              object-fit: cover !important;
              object-position: center !important;
            }
          }
        `}
      </style>

      <div style={{ width: "100%", margin: 0, padding: 0 }}>
        <section
          id="hero"
          style={{
            width: "100vw",
            position: "relative",
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            marginTop: "120px",
            aspectRatio: "16 / 9",
            overflow: "hidden",
            backgroundColor: "#000",
            padding: 0,
          }}
        >
          {/* IMAGE CAROUSEL */}
          {images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`SORIN hero ${i + 1}`}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
                opacity: currentImage === i ? 1 : 0,
                transition: "opacity 2s ease-in-out", // ✅ Changed: 1s → 2s (lebih smooth)
              }}
            />
          ))}

          {/* SHOP NOW BUTTON */}
          <button
            onClick={() =>
              window.open(
                "https://shopee.co.id/perfumebysorin?entryPoint=ShopBySearch&searchKeyword=perfumebysorin",
                "_blank"
              )
            }
            style={{
              position: "absolute",
              bottom: "12%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "rgb(0, 0, 0)",
              color: "rgb(255, 255, 255)",
              padding: "clamp(8px, 1.2vw, 12px) clamp(24px, 3.5vw, 40px)",
              fontSize: "clamp(12px, 1.4vw, 16px)",
              fontWeight: "600",
              border: "none",
              borderRadius: "clamp(6px, 0.8vw, 8px)",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              zIndex: 10,
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgb(220, 129, 76)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "rgb(0, 0, 0)";
            }}
          >
            SHOP NOW
          </button>

          {/* CAROUSEL DOTS */}
          <div
            style={{
              position: "absolute",
              bottom: "3%",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "clamp(6px, 1vw, 10px)",
              zIndex: 10,
            }}
          >
            {images.map((_, idx) => (
              <div
                key={idx}
                onClick={() => setCurrentImage(idx)}
                style={{
                  width: "clamp(8px, 1vw, 10px)",
                  height: "clamp(8px, 1vw, 10px)",
                  borderRadius: "50%",
                  backgroundColor:
                    idx === currentImage ? "#fff" : "rgba(255, 255, 255, 0.4)",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                }}
              />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Hero;